import React from "react";
import PropTypes from "prop-types";
import { Route, Redirect } from "react-router-dom";

const RedirectRoute = ({ path, to }) => <Route path={path} render={() => <Redirect to={to} />} />;

RedirectRoute.propTypes = {
  path: PropTypes.string,
  to: PropTypes.string,
};

export default RedirectRoute;



// WEBPACK FOOTER //
// ./components/RedirectRoute.jsx